export const errorMessageContents = {
    'dari': {
        'This field is required': '	این قسمت الزامی است',
        'Invalid email address': 'این ایمیل آدرس درست نیست',
        'Invalid credentials': 'معلومات وارد شده نادرست است',
        'Invalid OTP': 'رمز عبور یکبار مصرف اشتباه است',
        'OTP expired': 'انقضای تاریخ مصرف رمز یکبار مصرف',
        'Invalid password': "رمز نامعتبر", 
        "Passwords do not match": "رمز عبور همخوانی ندارد",

    },
    'pashto': {
        "This field is required": "دا برخه لازمي ده",
        "Invalid email address": "دا برېښنالیک ناسم دی",
        "Invalid credentials": "داخل شوي معلومات ناسم دي",
        "Invalid OTP": "یو ځل کارېدونکی پسورډ ناسم دی",
        "OTP expired": "یو ځل کارېدونکي پسورډ له وخته تېر دی",
        "Invalid password": "ناسم پټنوم",
        "Passwords do not match": "پسورډ همخواني نه لري",

    },
    'uzbeki': {
        "This field is required": "بو  بولیم طلب قیلینه‌دی",
        "Invalid email address": "بو ایمیل آدرس توغری ایمس",
        "Invalid credentials": "کیریتیلگن معلومات درست ایمس",
        "Invalid OTP": "بیر مرته‌لیک پسورد خطا دیر",
        "OTP expired": "بیر مرته‌لیک پسورد نینگ عمل قیلیش مدتی توگه‌یدی",
        'Invalid password':"رمز عبور نامعتبر است",
        "Passwords do not match": "پسورد ماس کیلمه‌یدی",

    }
}